import { FilterModel } from '../../filter';

export const CampaignFilterKey = 'CAMPAIGN_FILTER';

export type CampaignStatusFilter = 'DRAFT' | 'SCHEDULED' | 'SENT';

export class CampaignFilterModel implements FilterModel {
  keyword?: string;
  workspaceId?: string;
  status?: CampaignStatusFilter;

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.workspaceId = data?.workspaceId;
    this.status = data?.status;
  }

  public scrubWorkspaceData(): void {
    this.workspaceId = undefined;
  }

  public getGraphQLFilter(): Record<string, unknown> {
    const filter: Record<string, unknown> = {};
    if (this.keyword) filter.keyword = this.keyword;
    if (this.workspaceId) filter.workspaceId = this.workspaceId;
    if (this.status) filter.status = this.status;
    return filter;
  }
}
